<div (mouseenter)="onMouseOver()" (mouseleave)="onMouseOut()">
    <div class="recommended-action">
        <div>
            <input type="text" [(ngModel)]="rcmAction.RecommendationTitle" placeholder="Add Title" id="add-recommendation-title" (blur)="saveValue()"/>

            <ng-container *ngFor="let rp of _Photos">
                <measurement-point-photos [figure_number]="0" [image_id]="rp.id" [image_data]="rp.data" [image_title]="rp.title" [image_comment]="rp.comment" [isRecommendationPhoto]="'true'" (removePhoto)="deleteImage($event)"
                                          [isLarge]="rp.isLarge" (toggleResize)="toggleRecommendationImageResize($event, rp.id)"></measurement-point-photos>
            </ng-container>

            <div id="add-recommendation-photo" class="add-recommendation" (click)="addImage()"><i class="material-icons button__icon">add</i>Add Photo</div>
            
            <edit-data [canEdit]="true" (clickOut)="saveText($event)" [value]="rcmAction.RecommendationText" [dataType]="'textarea'" (valueChanged)="saveText($event)" [vertResizeOnly]="true" [placeholderText]="_Placeholder"></edit-data>
        </div>
        
        <div class="remove-recommendation" (click)="deleteRecommendation()" *ngIf="displayToggleButton" matTooltip="Remove Recommendation">
            <i class="material-icons remove-recommendation__icon">clear</i>
        </div>
    </div>
</div>
